import type { AxiosResponse } from "axios";

import api from "../utils/AxiosInterceptor";

export const validateDocument = async (
  hash: string
): Promise<AxiosResponse<ResponseDocumentSignatures>> => {
  return api.get(`/api/v1/signatures/verify/${hash}`);
};

export const validateEnvelope = async (
  hash: string
): Promise<AxiosResponse<ResponseSignaturesEnvelope>> => {
  return api.get(`/api/v1/signature-batch/verify/${hash}`);
};

export const downloadDocumentZip = async (
  signatureId: string
): Promise<AxiosResponse<Blob>> => {
  return api.get(`/api/v1/signatures/${signatureId}/download-zip`, {
    responseType: "blob",
  });
};

export const downloadEnvelopeZip = async (
  signatureId: string
): Promise<AxiosResponse<Blob>> => {
  return api.get(`/api/v1/signature-batch/${signatureId}/download-zip`, {
    responseType: "blob",
  });
};
